import { object, string, number } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';
import { checkMinMaxObjectKeyValues } from 'common/utils/helpers';

/**
 * Genera el esquema de validación base para productos financieros
 * @param {Object} config - Configuración adicional de validaciones
 * @returns {Function} Función que retorna el esquema de validación
 */
export const createValidationSchema =
    (config = {}) =>
    (values) => {
        const {
            getMaxValueText,
            getMinValueText,
            REQUIRED_TEXT,
            NUMBER_TYPE_TEXT,
            MIN_ZERO_VALIDATION_TEXT,
            MAX_100_VALIDATION_TEXT,
        } = getValidationTexts();

        const baseSchema = {
            name: string().required(REQUIRED_TEXT).nullable(),
            parameters: object().shape({
                tax: number()
                    .typeError(NUMBER_TYPE_TEXT)
                    .min(0, MIN_ZERO_VALIDATION_TEXT)
                    .max(100, MAX_100_VALIDATION_TEXT)
                    .nullable(),
                terms: object()
                    .test(
                        'terms-range',
                        getMaxValueText('360') + ', ' + getMinValueText('1'),
                        (value) => checkMinMaxObjectKeyValues(value, 1, 360),
                    )
                    .nullable(),
            }),
            parameters_commission_credit: object().shape({
                unit: number().typeError(NUMBER_TYPE_TEXT).nullable(),
                value: number().when('unit', {
                    is: 0,
                    then: () =>
                        number()
                            .typeError(NUMBER_TYPE_TEXT)
                            .min(0, MIN_ZERO_VALIDATION_TEXT)
                            .max(100, MAX_100_VALIDATION_TEXT)
                            .nullable(),
                }),
            }),
            parameters_hitch: object().shape({
                unit: number().typeError(NUMBER_TYPE_TEXT).nullable(),
                value: number().when('unit', {
                    is: 0,
                    then: () =>
                        number()
                            .typeError(NUMBER_TYPE_TEXT)
                            .min(0, MIN_ZERO_VALIDATION_TEXT)
                            .max(100, MAX_100_VALIDATION_TEXT)
                            .nullable(),
                }),
            }),
            parameters_rate: object().shape({
                value: number()
                    .typeError(NUMBER_TYPE_TEXT)
                    .min(0, MIN_ZERO_VALIDATION_TEXT)
                    .max(100, MAX_100_VALIDATION_TEXT)
                    .nullable(),
            }),
        };

        // Permitir extensiones del partner
        if (config.extendSchema) {
            return object().shape(config.extendSchema(values, baseSchema));
        }

        return object().shape(baseSchema);
    };

/**
 * Validación por defecto sin extensiones
 */
export const validate = createValidationSchema();
